var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasRecruiterKpiPermission)?_c('div',{staticClass:"recruiter-kpi-content"},[_c('RecruiterKpiDashboard',{staticClass:"dashboard",attrs:{"notSaveQuery":"","hiddenFilterTitle":"","cascaderSize":"small"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }